<h1>Log Book</h1>

<mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
    <mat-tab label="Today">
        <app-workout [movementGroups]="movementGroups"></app-workout>
    </mat-tab>
    <mat-tab label="Calendar">
        <app-history [movementGroups]="movementGroups"></app-history>
    </mat-tab>
</mat-tab-group>